export interface MenuRouteProps {
  path: string
  key: string
  title: string
  exact?: boolean
  requiredAuth?: boolean
  icon?: string
  children?: MenuRouteProps[]
}

export const menuItems: MenuRouteProps[] = [
  {
    path: "/",
    key: "/",
    title: "DASHBOARD",
    icon: "dashboard",
  },
  {
    path: "/panel/create",
    key: "/panel/create",
    title: "创建面板",
    icon: "plus-square",
  },
  {
    path: "",
    key: "/panel/my",
    title: "我的面板",
    icon: "appstore",
    children: [],
  },
  {
    path: "",
    key: "/panel/example",
    title: "示例面板",
    icon: "italic",
    children: [],
  },
  {
    path: "",
    key: "/datasource",
    title: "数据源",
    icon: "database",
    children: [
      {
        path: "/datasource/file",
        key: "/datasource/file",
        title: "数据源文件",
      },
    ],
  },
]
